import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataDateTime,
  HeaderAlignment,
  ODataDate
} from "pbas-vue-components";

const headers = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.expense_info.din",
    type: new ODataString("Din", { alignment: HeaderAlignment.Left }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Name"),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.effective_date",
    type: new ODataDate("EffectiveDate"),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.drugs.deactivated_at",
    type: new ODataDate("DeactivatedAt"),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default headers;
